<template>
    <Layout class="layout-white">
        <router-link to="/app/login" class="employee-login-link" title="Employee login">
            <Icon type="ios-log-in" size="24" />
        </router-link>
        <Content style="display: flex">
            <div style="margin: auto; text-align: center">
                <img src="../assets/hmotors-logo-new.png">
                <div class="main-block-style">
                    <router-link to="/customer/login" class="main-link-style">
                        <template>Customer login</template>
                    </router-link>
                </div>
            </div>
        </Content>
    </Layout>
</template>

<script>
  export default {}
</script>

<style>
    .main-block-style {
        padding-top: 20px;
    }
    .main-link-style {
        font-size: 20px;
        color: black;
    }
    .employee-login-link {
        position: fixed;
        top: 16px;
        right: 16px;
        color: #999;
        line-height: 1;
    }
    .employee-login-link:hover {
        color: black;
    }
</style>
